module.exports = __webpack_public_path__ + "static/img/cover10.cf2369a3.jpg";